var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 1.1C13 1.04477 12.9552 1 12.9 1H1.1C1.04477 1 1 1.04477 1 1.1V7.025C1 7.08023 1.04477 7.125 1.1 7.125H2.61429C2.66951 7.125 2.71429 7.16977 2.71429 7.225V12.319C2.71429 12.3538 2.73238 12.3861 2.76205 12.4043L6.94777 14.968C6.97982 14.9876 7.02018 14.9876 7.05223 14.968L11.2379 12.4043C11.2676 12.3861 11.2857 12.3538 11.2857 12.319V7.225C11.2857 7.16977 11.3305 7.125 11.3857 7.125H12.9C12.9552 7.125 13 7.08023 13 7.025V1.1Z",
    stroke: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachine);
export default __webpack_public_path__ + "static/media/machine.77258e71785f1f7a0faa69cc3e841335.svg";
export { ForwardRef as ReactComponent };